<span>
  <ui-button (click)="!disabled && save()" option="primary" [label]="label || 'SUBMIT AND CONTINUE'" [isInvalid]="disabled" type="button"></ui-button>
</span>
